export const URL_TITLES = {
    termsAndConditions: "Términos y condiciones",
    personalDataTreatment: "Autorización de tratamiento de datos personales",
    privacyPolicy: "Políticas de privacidad",
} as const;
